<template>
  <div
    class="py-4 text-red font-weight-bold"
    style="white-space: pre-line; font-size: 12px"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "ConsultationWarningNotice",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>
